import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';

import { ReferenceBlock } from '../../components/reference-block';

export interface ConfluenceReferenceNodeAttributes {
  url: string;
  name: string;
  type?: string;
}

export const ConfluenceReferenceNode = Node.create({
  name: 'confluenceReferenceNode',
  group: 'block',
  atom: true,
  inline: false,
  selectable: false,
  draggable: true,

  parseHTML() {
    return [{ tag: 'confluence-reference-node' }];
  },
  renderText({ node }) {
    return node.attrs.url;
  },
  renderHTML({ HTMLAttributes }) {
    return ['confluence-reference-node', mergeAttributes(HTMLAttributes)];
  },
  addNodeView() {
    return ReactNodeViewRenderer((props) => <ReferenceBlock {...props} source="confluence" />);
  },
  addAttributes() {
    return {
      url: {
        default: undefined,
      },
      name: {
        default: undefined,
      },
      type: {
        default: undefined,
      },
    };
  },
});
